(function () {

    var formApp = angular.module('formApp');

    // this controller is use executes the functionality in feedback landing page
    formApp.controller('feedbackStaffMemberLandingController', ['$scope', '$rootScope', '$location', 'adalAuthenticationService', 'UtilityServices', 'DataServices', 'Constants',
        function ($scope, $rootScope, $location, adalAuthenticationService, UtilityServices, DataServices, Constants) {

            // this sets the page title
            document.title = 'Feedback Management System';

            DataServices.incidentSubmitted = false;

            $scope.isLoading = false;
            $scope.utility = UtilityServices;
            var baseurl = window.location;
            var urldffh = baseurl + 'DFFH';
            var urldh = baseurl + 'DH';
            $scope.dffhURL = urldffh
            $scope.dhURL = urldh

            if ($location.path().indexOf('DH') > -1) {
                $scope.IsDHVisible = true;
                //return true;
            }
            else {
                $scope.IsDHVisible = false;
            }
            if ($location.path().indexOf('DFFH') > -1) {
                $scope.IsDFFHVisible = true;
                //return true;
            }
            else {
                $scope.IsDFFHVisible = false;
            }

            // this gets and set the config data 
            var getConfigDataAndRedirect = function (templateId, destinationPath) {

                $scope.isLoading = true;
                setDefaultValues();
                DataServices.validationErrors = [];

                DataServices.getConfigurationUsingCache(templateId, null, null, DataServices.isAuthenticated())
                    .then(function (data) {
                        $location.path(destinationPath);
                    })
                    .finally(function () {
                        $scope.isLoading = false;
                    });

                $rootScope.allowFormNavigation = true;
            }

            $scope.createFeedback = function () {
                if (!DataServices.isSessionActive()) {
                    adalAuthenticationService.login();
                    return false;
                }
                getConfigDataAndRedirect(Constants.ConfigTemplate.complaint, Constants.Url.firstComplaintFormPage);
            }

            var setDefaultValues = function () {
                DataServices.responseInfo.responses = {};
                DataServices.responseInfo.lastUpdatedTime = null;
                DataServices.responseInfo.incidentId = null;
                DataServices.responseInfo.incidentRef = null;
                DataServices.responseInfo.reportedDate = null;
                DataServices.responseInfo.status = null;
                DataServices.responseInfo.submittedDate = null;
            }
        }]);
}());